export const setCommunes = (state, params) => {
	const { payload: communes } = params;
	state.communes = communes;
	return state;
};

export default {};